import history from '../history';

const resetSearchParams = (params = {}) => {
  const { pathname, search } = history.location;
  const currentParams = Object.fromEntries(new URLSearchParams(search));
  
  // Filter keys that should be preserved when resetting (like filters)
  const filterKeys = ['id', 'name', 'contactName', 'contactEmail', 'status', 'programName', 'sediBusiness', 'watchables', 'calcapLoanNumber'];
  
  // Preserve filter params when resetting other params (like tab)
  const preservedParams = {};
  filterKeys.forEach(key => {
    if (currentParams[key]) {
      preservedParams[key] = currentParams[key];
    }
  });
  
  // Merge preserved params with new params (new params take precedence)
  const mergedParams = { ...preservedParams, ...params };
  
  if (Object.keys(mergedParams).length) {
    history.replace(`${pathname}?${new URLSearchParams(mergedParams).toString()}`);
  } else {
    history.replace(pathname);
  }
};

export default resetSearchParams;
